
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import CategoriesSection from './components/CategoriesSection';
import FeaturedDeals from './components/FeaturedDeals';
import TopPicksSection from './components/TopPicksSection';
import WhyTrustUs from './components/WhyTrustUs';
import TestimonialsSection from './components/TestimonialsSection';
import NewsletterSection from './components/NewsletterSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-carbon-950">
      <Navbar />
      <HeroSection />
      <StatsBar />
      <CategoriesSection />
      <FeaturedDeals />
      <TopPicksSection />
      <WhyTrustUs />
      <TestimonialsSection />
      <NewsletterSection />
      <Footer />
    </div>
  );
}
